'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const defaultFont = 'var(--zds-typography-base, "Inter", Helvetica, arial, sans-serif)';
const displayFont = 'var(--zds-typography-heading-display, "Degular Display", Helvetica, arial, sans-serif)';
const LegacyTypography = {
  // For use cases where styles are unique but the same
  // `fontFamily` should be used.
  base: {
    fontFamily: defaultFont
  },
  heading: {
    fontFamily: displayFont
  },
  // Page headers
  pageHeader1: {
    fontFamily: displayFont,
    fontSize: "82px",
    lineHeight: "84px",
    fontWeight: "700",
    letterSpacing: "1px"
  },
  pageHeader3: {
    fontFamily: displayFont,
    fontSize: "62px",
    lineHeight: "66px",
    fontWeight: "700",
    letterSpacing: "1px"
  },
  pageHeader4: {
    fontFamily: displayFont,
    fontSize: "52px",
    lineHeight: "60px",
    fontWeight: "700",
    letterSpacing: "1px"
  },
  pageHeader5: {
    fontFamily: displayFont,
    fontSize: "42px",
    lineHeight: "50px",
    fontWeight: "600",
    letterSpacing: "1px"
  },
  pageHeader7: {
    fontFamily: displayFont,
    fontSize: "34px",
    lineHeight: "40px",
    fontWeight: "600",
    letterSpacing: "1px"
  },
  pageHeader9: {
    fontFamily: displayFont,
    fontSize: "26px",
    lineHeight: "32px",
    fontWeight: "600",
    letterSpacing: "1px"
  },
  // Section headers
  sectionHeader1: {
    fontFamily: defaultFont,
    fontSize: 32,
    lineHeight: "35px",
    fontWeight: 700,
    letterSpacing: "normal"
  },
  sectionHeader1Extrabold: {
    fontFamily: defaultFont,
    fontSize: 32,
    lineHeight: "35px",
    fontWeight: 800,
    letterSpacing: "normal"
  },
  sectionHeader1Medium: {
    fontFamily: defaultFont,
    fontSize: 32,
    lineHeight: "35px",
    fontWeight: 500,
    letterSpacing: "normal"
  },
  sectionHeader1Bold: {
    fontFamily: defaultFont,
    fontSize: 32,
    lineHeight: "35px",
    fontWeight: 700,
    letterSpacing: "normal"
  },
  sectionHeader3: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 700,
    letterSpacing: "normal"
  },
  sectionHeader3Extrabold: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 800,
    letterSpacing: "normal"
  },
  sectionHeader3Semibold: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 600,
    letterSpacing: "normal"
  },
  sectionHeader3Bold: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 700,
    letterSpacing: "normal"
  },
  // Subheaders
  subHeader1: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 400
  },
  subHeader1Semibold: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 600
  },
  subHeader1Bold: {
    fontFamily: defaultFont,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 700
  },
  subHeader3: {
    fontFamily: defaultFont,
    fontSize: 22,
    lineHeight: "28px",
    fontWeight: 400
  },
  subHeader3Medium: {
    fontFamily: displayFont,
    fontSize: 22,
    lineHeight: "28px",
    fontWeight: 500,
    letterSpacing: "1px"
  },
  subHeader3Bold: {
    fontFamily: displayFont,
    fontSize: 22,
    lineHeight: "28px",
    fontWeight: "600",
    letterSpacing: "1px"
  },
  subHeader5: {
    fontFamily: defaultFont,
    fontSize: 20,
    lineHeight: "26px",
    fontWeight: 400
  },
  subHeader5Medium: {
    fontFamily: displayFont,
    fontSize: 20,
    lineHeight: "26px",
    fontWeight: 500,
    letterSpacing: "1px"
  },
  subHeader5Bold: {
    fontFamily: displayFont,
    fontSize: 20,
    lineHeight: "26px",
    fontWeight: "600",
    letterSpacing: "1px"
  },
  // Supertitles
  superTitle1: {
    fontFamily: defaultFont,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 700,
    textTransform: "uppercase"
  },
  superTitle3: {
    fontFamily: defaultFont,
    fontSize: 12,
    lineHeight: "15px",
    fontWeight: 700,
    textTransform: "uppercase"
  },
  superTitle5: {
    fontFamily: defaultFont,
    fontSize: 10,
    lineHeight: "15px",
    fontWeight: 700,
    textTransform: "uppercase"
  },
  // Paragraphs
  paragraph1: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "31px",
    fontWeight: 400
  },
  paragraph1Medium: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "31px",
    fontWeight: 500
  },
  paragraph1Semibold: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "31px",
    fontWeight: 600
  },
  paragraph1Bold: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "31px",
    fontWeight: 700
  },
  paragraph1Short: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 400
  },
  paragraph1ShortMedium: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 500
  },
  paragraph1ShortSemibold: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 600
  },
  paragraph1ShortBold: {
    fontFamily: defaultFont,
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 700
  },
  paragraph3: {
    fontFamily: defaultFont,
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 400
  },
  paragraph3Medium: {
    fontFamily: defaultFont,
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 500
  },
  paragraph3Semibold: {
    fontFamily: defaultFont,
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 600
  },
  paragraph3Bold: {
    fontFamily: defaultFont,
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 700
  },
  // Small print
  smallPrint1: {
    fontFamily: defaultFont,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 400
  },
  smallPrint1Medium: {
    fontFamily: defaultFont,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500
  },
  smallPrint1Semibold: {
    fontFamily: defaultFont,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 600
  },
  smallPrint1Bold: {
    fontFamily: defaultFont,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 700
  },
  smallPrint3: {
    fontFamily: defaultFont,
    fontSize: 12,
    lineHeight: "15px",
    fontWeight: 400
  },
  smallPrint3Semibold: {
    fontFamily: defaultFont,
    fontSize: 12,
    lineHeight: "15px",
    fontWeight: 600
  },
  smallPrint3Bold: {
    fontFamily: defaultFont,
    fontSize: 12,
    lineHeight: "15px",
    fontWeight: 700
  }
};

exports.LegacyTypography = LegacyTypography;
//# sourceMappingURL=LegacyTypography.cjs.js.map
